import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'square-button',
  templateUrl: './square-button.component.html',
  styleUrls: ['./square-button.component.scss'],
  imports: [
    FormsModule
  ],
  standalone: true
})
export class SquareButtonComponent {
  @Input() label = '';
  @Input() labelSuffix?: string;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() disabled: boolean = false;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() testId = '';
}
